// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3QCOd","empty":"ModalGraph_empty__8A32s"};